// extracted by mini-css-extract-plugin
module.exports = {"homeSeoLinks":"_21Bb","item":"dC2K","collapse":"_2usp","head":"_33BE","content":"_2nCR","control":"_1EKL"};